// Hand-written (not generated) — mirrors the shape of the generated handlers
// in this directory, same as onboarding.ts. Backend contract: himam-nest
// src/organizations-system/resources/student-feedback/* (internal-team-mode
// gated: student questions + per-module ratings).
export const studentFeedbackApiHandler = {
  createQuestion: {
    method: 'POST',
    path: () => `student-questions`,
  },
  listMyQuestions: {
    method: 'GET',
    path: () => `student-questions/mine`,
  },
  upsertModuleRating: {
    method: 'PUT',
    path: (payload: { checklistId: number }) =>
      `student-modules/${payload.checklistId}/rating`,
  },
};
